// fill in both in order to get proper intellisense
export type BaseDict = {
    Example: string
}
export const BaseDict: BaseDict = {
    Example: "Translated Example"
}